module.exports = __webpack_public_path__ + "static/img/7.62e384a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/7.png
// module id = R08z
// module chunks = 0